<template>
  <!-- Main Sidebar Container -->
  <aside class="main-sidebar sidebar-dark-primary elevation-4" style="background-color: #354777;">
    <!-- Sidebar -->
    <a class="brand-link text-right" data-widget="pushmenu" href="#" role="button" style="color: aliceblue;font-size: large;background-color: #354777;">
      <i class="fas fa-align-right"></i>
    </a>
    <div class="sidebar" style="border-top: solid 10px #ffc107;background-color: #343a40;">
      <!-- SidebarSearch Form -->
      <div class="form-inline">
        <div class="input-group" data-widget="sidebar-search">
          <input class="form-control form-control-sidebar" type="search" placeholder="Cari Menu" aria-label="Cari Menu">
          <div class="input-group-append">
            <button class="btn btn-sidebar">
              <i class="fas fa-search fa-fw"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Sidebar Menu -->
      <nav class="mt-2">
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
          <!-- Add icons to the links using the .nav-icon class
               with font-awesome or any other icon font library -->
          <li class="nav-item menu-open" id="DashboardGrup" style="margin-top: 2px;">
            <a href="#" class="nav-link" style="display:none">
              <i class="nav-icon fas fa-tachometer-alt"></i>
              <p>
                Home
                <i class="right fas fa-angle-left"></i>
              </p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link to="/DashboardSDA" class="nav-link"><i class="nav-icon fas fa-tachometer-alt"></i>
                  <p>Dashboard</p>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item menu-open" id="PetaGrup" style="margin-top: 2px;">
            <a href="#" class="nav-link" style="display:none">
              <i class="nav-icon fas fa-tachometer-alt"></i>
              <p>
                Peta
                <i class="right fas fa-angle-left"></i>
              </p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link to="/Peta" class="nav-link"><i class="nav-icon fas fa-map"></i>
                  <p>Peta</p>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item menu-open" id="MonitoringGrup">
            <a href="#" class="nav-link">
              <i class="nav-icon fas fa-th"></i>
              <p>
                E-monitoring
                <i class="right fas fa-angle-left"></i>
              </p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link to="/RekapSDABalai" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Rekapitulasi SDA/Balai</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/RekapLender" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Rekapitulasi Per Lender</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/RekapPerProyek" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Rekapitulasi Per Proyek</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/RekapPerRegister" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Rekapitulasi Per Register</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/DetailProgres" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Detail Progres F&K</p>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item menu-open" id="PaketKontraktualGrup">
            <a href="#" class="nav-link">
              <i class="nav-icon fas fa-copy"></i>
              <p>
                Paket Kontraktual
                <i class="right fas fa-angle-left"></i>
              </p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link to="/PaketSDABalai" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Rekapitulasi SDA/Balai</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/PaketPerProyek" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Rekapitulasi Per Proyek</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/DetailPaket" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Detail Paket Kontraktual</p>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item menu-open" id="PaketPipeLineGrup">
            <a href="#" class="nav-link">
              <i class="nav-icon fas fa-plus-square"></i>
              <p>
                Pipeline
                <i class="right fas fa-angle-left"></i>
              </p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link to="/PipelineRekapSDABalai" class="nav-link"><i
                    class="nav-icon far fa-circle text-warning"></i>
                  <p>Rekapitulasi SDA/Balai</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/PipelineRekapLender" class="nav-link"><i
                    class="nav-icon far fa-circle text-warning"></i>
                  <p>Rekapitulasi Per Lender</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/PipelineRekapPerProyek" class="nav-link"><i
                    class="nav-icon far fa-circle text-warning"></i>
                  <p>Rekapitulasi Per Proyek</p>
                </router-link>
              </li>
              <li class="nav-item" style="display: none;">
                <router-link to="/PipelineRekapPerRegister" class="nav-link"><i
                    class="nav-icon far fa-circle text-warning"></i>
                  <p>Rekapitulasi Per Register</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/PipelineDetailProgres" class="nav-link"><i
                    class="nav-icon far fa-circle text-warning"></i>
                  <p>Detail Paket</p>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item menu-open" id="PrognosisGrup">
            <a href="#" class="nav-link">
              <i class="nav-icon fas fa-chart-pie"></i>
              <p>
                Prognosis
                <i class="right fas fa-angle-left"></i>
              </p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link to="/PrognosisSDABalai" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Rekapitulasi SDA/Balai</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/PrognosisLender" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Rekapitulasi Per Lender</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/PrognosisPerProyek" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Rekapitulasi Per Proyek</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/PrognosisPerRegister" class="nav-link"><i
                    class="nav-icon far fa-circle text-warning"></i>
                  <p>Rekapitulasi Per Register</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/PrognosisProgres" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Detail Prognosis Paket</p>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item menu-open" id="KendalaGrup">
            <a href="#" class="nav-link">
              <i class="nav-icon fas fa-book"></i>
              <p>
                Kendala & Tindak Lanjut
                <i class="right fas fa-angle-left"></i>
              </p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link to="/KendalaSDABalai" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Rekapitulasi SDA/Balai</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/KendalaLender" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Rekapitulasi Per Lender</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/KendalaPerProyek" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Rekapitulasi Per Proyek</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/KendalaProgres" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Detail Paket</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/KendalaTindakLanjutPerPaket" class="nav-link"><i
                    class="nav-icon far fa-circle text-warning"></i>
                  <p>Input Kendala dan TL</p>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item menu-open" id="AWPGrup">
            <a href="#" class="nav-link">
              <i class="nav-icon fas fa-edit"></i>
              <p>
                AWP
                <i class="right fas fa-angle-left"></i>
              </p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link to="/AWPSDABalai" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Rekapitulasi SDA/Balai</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/AWPPerProyek" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Rekapitulasi Per Proyek</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/AWPDetailBalai" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Detail AWP Per Balai<br>Per Proyek</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/AWPMapping" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Mapping AWP vs DIPA Per Balai Per Proyek</p>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item menu-open" id="PengecekanGrup">
            <a href="#" class="nav-link">
              <i class="nav-icon fas fa-wrench"></i>
              <p>
                Pengecekan DIPA
                <i class="right fas fa-angle-left"></i>
              </p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link to="/KesalahanPorsi" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Kesalahan Porsi</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/KesalahanKodeBeban" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Kesalahan Kode Beban</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/KesalahanKodeKPPN" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Kesalahan Kode KPPN</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/PaketKodeProyekL1" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Paket Kode Proyek > 1</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/PaketKodeSubPaketL1" class="nav-link"><i
                    class="nav-icon far fa-circle text-warning"></i>
                  <p>Paket - Sub Paket > 1</p>
                </router-link>
              </li>
              <li class="nav-item" style="display: none;">
                <router-link to="/DIPAPaketLAWP" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>DIPA Paket > AWP</p>
                </router-link>
              </li>
              <li class="nav-item" style="display: none;">
                <router-link to="/DaftarPaketKontraktual" class="nav-link"><i
                    class="nav-icon far fa-circle text-warning"></i>
                  <p>Daftar Paket Kontraktual</p>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item menu-open" id="FormIsianGrup">
            <a href="#" class="nav-link">
              <i class="nav-icon fas fa-table"></i>
              <p>
                Form Isian Balai
                <i class="right fas fa-angle-left"></i>
              </p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link to="/FormMappingAWP" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Mapping AWP</p>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item menu-open" id="KompilasiGrup">
            <a href="#" class="nav-link">
              <i class="nav-icon fas fa-columns"></i>
              <p>
                Kompilasi
                <i class="right fas fa-angle-left"></i>
              </p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link to="/KompilasiRegister" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Kompilasi Data</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/OWPAWP" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Kompilasi OWP, AWP & Realisasi Per Proyek</p>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item menu-open" id="ADKGrup" style="display: none;">
            <a href="#" class="nav-link">
              <i class="nav-icon 	fas fa-archive"></i>
              <p>
                Tools ADK
                <i class="right fas fa-angle-left"></i>
              </p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link to="/ADKResume" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Resume ADK</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/ADKVersi" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Versi ADK</p>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item menu-open" id="ManajemenGrup">
            <a href="#" class="nav-link">
              <i class="nav-icon 	fas fa-coins"></i>
              <p>
                Manajemen Data
                <i class="right fas fa-angle-left"></i>
              </p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link to="/ManajemenUser" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Data User</p>
                </router-link>
              </li>
              <li class="nav-item" style="display: none;">
                <router-link to="/ManajemenPorsi" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Data Porsi Loan</p>
                </router-link>
              </li>
              <li class="nav-item" style="display: none;">
                <router-link to="/ManajemenSatker" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Data Satker</p>
                </router-link>
              </li>
              <li class="nav-item" style="display: none;">
                <router-link to="/ManajemenAkunRegister" class="nav-link"><i
                    class="nav-icon far fa-circle text-warning"></i>
                  <p>Data Akun Register</p>
                </router-link>
              </li>
              <li class="nav-item" style="display: none;">
                <router-link to="/ManajemenRegister" class="nav-link"><i class="nav-icon far fa-circle text-warning"></i>
                  <p>Data Register</p>
                </router-link>
              </li>
              <li class="nav-item" style="display: none;">
                <router-link to="/ManajemenKegiatanPerDirektorat" class="nav-link"><i
                    class="nav-icon far fa-circle text-warning"></i>
                  <p>Kegiatan Per Direktorat</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/ManajemenUploadDataEmon" class="nav-link"><i
                    class="nav-icon far fa-circle text-warning"></i>
                  <p>Upload Data Emon</p>
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
      <!-- /.sidebar-menu -->
    </div>
    <!-- /.sidebar -->
  </aside>
</template>

<script>
export default {
}
</script>

<style></style>